import {
  type SiteMenuBeverageOrder,
  type SiteMenuSupplyOrder,
  type Beverage,
  type Supply,
} from '../entities';

interface FlatSiteMenuBeverageOrder {
  id: string | undefined;
  unitPrice: number;
  totalPrice: number;
  quantity: number;
  isExtraBeverage: boolean;
  beverageName: string;
  beverage: Beverage;
}

// Please, avoid using spread operator, to have control on the object structure.
export const flattenSiteMenuBeverageOrder = (
  smbo: SiteMenuBeverageOrder
): FlatSiteMenuBeverageOrder => {
  return {
    id: smbo?.id,
    unitPrice: smbo?.unitPrice,
    totalPrice: smbo?.totalPrice,
    quantity: smbo?.quantity,
    isExtraBeverage: smbo?.isExtraBeverage,
    beverageName: smbo?.beverageName,
    beverage: {
      id: smbo?.beverage?.id,
      name: smbo?.beverage?.name,
      description: smbo?.beverage?.description,
      price: smbo?.beverage?.price,
      isTestable: smbo?.beverage?.isTestable,
      isExtra: smbo?.beverage?.isExtra,
    },
  };
};

interface FlatSiteMenuSupplyOrder {
  id: string | undefined;
  unitPrice: number;
  totalPrice: number;
  supplyName: string;
  quantity: number;
  supply: Supply;
}

// Please, avoid using spread operator, to have control on the object structure.
export const flattenSiteMenuSupplyOrder = (smso: SiteMenuSupplyOrder): FlatSiteMenuSupplyOrder => {
  return {
    id: smso?.id,
    unitPrice: smso?.unitPrice,
    totalPrice: smso?.totalPrice,
    quantity: smso?.quantity,
    supplyName: smso?.supplyName,
    supply: {
      id: smso?.supply?.id,
      name: smso?.supply?.name,
      description: smso?.supply?.description,
      price: smso?.supply?.price,
    },
  };
};
